import Link from "next/link";

export function LandingFooter() {
  return (
    <footer className="bg-landing-cream w-full border-t border-landing-text-secondary/10">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 sm:gap-12 px-4 sm:px-8 py-16 max-w-7xl mx-auto">
        <div className="col-span-2 lg:col-span-1">
          <div className="text-2xl font-bold text-landing-text mb-6">Dezu</div>
          <div className="flex gap-4">
            <a
              href="https://linkedin.com/company/dezuai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-landing-text-secondary hover:text-landing-primary transition-colors"
              aria-label="LinkedIn"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-landing-text mb-6 text-sm">Product</h4>
          <ul className="space-y-4 text-sm text-landing-text-secondary">
            <li><Link href="/#how-it-works" className="hover:text-landing-primary transition-colors">How it Works</Link></li>
            <li><Link href="/#features" className="hover:text-landing-primary transition-colors">Features</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-landing-text mb-6 text-sm">Resources</h4>
          <ul className="space-y-4 text-sm text-landing-text-secondary">
            <li><Link href="/login" className="hover:text-landing-primary transition-colors">Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-landing-text mb-6 text-sm">Company</h4>
          <ul className="space-y-4 text-sm text-landing-text-secondary">
            <li><Link href="/security" className="hover:text-landing-primary transition-colors">Security</Link></li>
            <li><Link href="/privacy-policy" className="hover:text-landing-primary transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-landing-text mb-6 text-sm">Contact</h4>
          <ul className="space-y-4 text-sm text-landing-text-secondary">
            <li><a href="mailto:founders@dezu.ai" className="hover:text-landing-primary transition-colors">founders@dezu.ai</a></li>
            <li><a href="mailto:support@dezu.ai" className="hover:text-landing-primary transition-colors">support@dezu.ai</a></li>
          </ul>
        </div>
      </div>

      <div className="px-4 sm:px-8 py-8 max-w-7xl mx-auto border-t border-landing-text-secondary/5 flex flex-col md:flex-row justify-between items-center gap-4">
        <span className="text-xs text-landing-text-secondary opacity-60">
          Copyright © {new Date().getFullYear()} Dezu, Inc. All rights reserved.
        </span>
        <div className="flex gap-8 text-xs text-landing-text-secondary opacity-60">
          <Link href="/privacy-policy" className="hover:text-landing-text transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
